import { runOnPage } from './general.js';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

runOnPage('our-story-default', () => {
	$(document).ready(function () {
		const $container = $('#image-container');
		let containerWidth = 0;
		let containerHeight = 0;
		let highestZIndex = 1;
		let cardsInitialized = false;

		function updateContainerSize() {
			containerWidth  = $container.width();
			containerHeight = window.innerHeight;
		}

		function updateStackOrder() {
			$container
				.children('.draggable')
				.each(function (i) {
					$(this).css('z-index', $container.children('.draggable').length - i);
				});
		}

		function centerNewTopCard() {
			const $newTop = $container.children('.draggable').first();
			if (!$newTop.length) return;

			const { width, height } = $newTop[0].getBoundingClientRect();
			const centerLeft = (containerWidth - width) / 2;
			const centerTop  = (containerHeight - height) / 2;

			$newTop
				.css({ transition: 'none', left: centerLeft, top: centerTop, transform: 'rotate(0deg) scale(1)' });
			requestAnimationFrame(() => {
				$newTop.css('transition', 'all .4s ease-in-out');
			});
		}

		const isMobile = () => window.innerWidth <= 640;

		function initializeCards() {
			if (cardsInitialized) return;
			cardsInitialized = true;

			updateContainerSize();

			$(window).on('resize.aboutCards', () => {
				const wasMobile = isMobile();
				updateContainerSize();
				if (wasMobile !== isMobile()) {
					centerNewTopCard();
				}
			});

			$container.find('.draggable').each(function (index) {
				const $img = $(this);
				if (isMobile()) {
					setupMobileCard($img, index);
				} else {
					setupDesktopCard($img, index);
				}
				bindCommonHandlers($img);
			});
		}

		function setupMobileCard($img, index) {
			const rotRange        = 5;      // ±5°
			const spacingFactor   = 1.25;   // svislá rozteč
			const jitterFactorY   = 0.10;   // Y-jitter
			const vPaddingPct     = 0.05;   // horní/dolní mezera

			/*  cik-cak parametry  */
			const sidePaddingPct  = 0.15;   // 15 % vnitřní okraj
			const zigZagShiftPct  = 0.20;   // karty vyjedou o ±10 % šířky kontejneru
			const jitterFactorX   = 0.03;   // malý X-jitter (3 % šířky)

			const rot   = (Math.random() * 2 - 1) * rotRange;
			const w     = $img.outerWidth();
			const h     = $img.outerHeight();
			const count = $container.children('.draggable').length;

			const usableHeight = containerHeight * (1 - 2 * vPaddingPct) - h;
			const rawStepY     = count > 1 ? usableHeight / (count - 1) : 0;
			const stepY        = rawStepY * spacingFactor;
			const jitterY      = stepY * jitterFactorY;

			const baseTop = containerHeight * vPaddingPct + (count - index - 1) * stepY;
			let   top     = baseTop + (Math.random() * 2 - 1) * jitterY;

			const minTop = containerHeight * vPaddingPct;
			const maxTop = containerHeight - h + h * 0.05;
			top = Math.max(minTop, Math.min(maxTop, top));

			const coreLeft  = containerWidth * sidePaddingPct;
			const coreRight = containerWidth - w - coreLeft;

			const sideShift = containerWidth * zigZagShiftPct;
			const jitterX   = containerWidth * jitterFactorX * (Math.random() * 2 - 1);

			let left;
			if (index % 2 === 0) {
				left = coreLeft - sideShift + jitterX;
				left = Math.max(0, left);
			} else {
				left = coreRight + sideShift + jitterX;
				left = Math.min(containerWidth - w, left);
			}

			setTimeout(() => {
				$img.css({
					position : 'absolute',
					left     : `${left}px`,
					top      : `${top}px`,
					transform: `rotate(${rot}deg)`,
					zIndex   : count - index
				}).animate({ opacity: 1 }, 300);
			}, (count - index - 1) * 200);

			$img.on('touchend.aboutCards click.aboutCards', function (e) {
				e.preventDefault();
				$img.prependTo($container);
				updateStackOrder();
			});
		}

		const cardPositions = [
			{ left:  "75%",  top: "58%" },  // phone
			{ left: "13%",  top: "62%" },   // at a location
			{ left: "80%",  top: "18%" },   // blueinfo
			{ left: "60%",  top: "60%" },   // the system
			{ left: "10%",  top: "7%" },    // karluv most
			{ left: "23%",   top: "15%" },  // castle
			{ left: "64%",  top: "10%" }    // pardubickydenik.cz
		];

		function setupDesktopCard($img, index) {
			const rot = Math.random() * 20 - 10;
			const w   = $img.outerWidth();
			const h   = $img.outerHeight();
			const containerWidth  = $container.width();
			const containerHeight = $container.height();

			const pos = cardPositions[index];
			const final = {
				left: parseFloat(pos.left) / 100 * containerWidth,
				top:  parseFloat(pos.top)  / 100 * containerHeight
			};

			const sides = [
				{ left: -w - 40,            top: final.top },
				{ left: containerWidth+40,  top: final.top },
				{ left: final.left,         top: -h - 40 },
				{ left: final.left,         top: containerHeight + h + 40 }
			];

			$img.css({
				...sides[Math.floor(Math.random() * 4)],
				opacity:   0,
				transform: `rotate(${rot}deg)`,
				position:  'absolute',
				transition: 'all 1.1s cubic-bezier(0.22, 1, 0.36, 1)'
			})
				.on('mouseenter', function () {
					$(this).css('z-index', ++highestZIndex);
				});

			const baseDelayDesktop = 500;
			const randomRange      = 1100;
			setTimeout(() => {
				$img.css({
					left:       final.left,
					top:        final.top,
					opacity:    1,
					transform:  `rotate(${rot}deg)`
				});
			}, baseDelayDesktop + Math.random() * randomRange);

			$img.on('mousedown.aboutCards', function (e) {
				const rect = this.getBoundingClientRect();
				const shift = { x: e.clientX - rect.left, y: e.clientY - rect.top };
				$img.css('transition', 'none');
				function moveAt(pageX, pageY) {
					const cOff = $container.offset();
					$img.css({ left: pageX - shift.x - cOff.left, top: pageY - shift.y - cOff.top });
				}
				$(document)
					.on('mousemove.aboutCards', ev => moveAt(ev.pageX, ev.pageY))
					.one('mouseup.aboutCards', () => {
						$(document).off('mousemove.aboutCards');
						$img.css('transition', 'all .2s ease');
					});
				e.preventDefault();
			});
		}

		function bindCommonHandlers($img) {
			$img.on('dragstart.aboutCards', () => false);

			const $toggle  = $img.find('.info-toggle');
			const $infoBox = $img.find('.info-box');
			if ($toggle.length && $infoBox.length) {
				$toggle.on('click.aboutCards touchend.aboutCards', e => {
					e.preventDefault();
					$infoBox.toggleClass('hidden');
					$toggle.toggleClass('icon-question-mark-filled icon-minus');
				});
			}
		}

		if ('IntersectionObserver' in window) {
			new IntersectionObserver((entries, obs) => {
				if (entries[0].isIntersecting) {
					initializeCards();
					obs.disconnect();
				}
			}, { threshold: 0.1 })
				.observe($container[0]);
		} else {
			$(window).on('scroll.lazyCards', () => {
				if (!cardsInitialized &&
					$(window).scrollTop() + $(window).height() > $container.offset().top
				) {
					initializeCards();
					$(window).off('scroll.lazyCards');
				}
			});
		}

		const $dragWrapper = $('#draggable-circle').closest('.draggable-wrapper');
		const circle = document.getElementById('draggable-circle');
		if ($dragWrapper.length && circle) {
			$dragWrapper.css('position','relative');

			let isDragging = false;
			let startX = 0, startY = 0, origX = 0, origY = 0;

			function onStart(e) {
				const evt = (e.touches ? e.touches[0] : e);
				isDragging = true;
				startX     = evt.clientX;
				startY     = evt.clientY;
				origX      = circle.offsetLeft;
				origY      = circle.offsetTop;
				circle.style.cursor = 'grabbing';
				document.addEventListener('mousemove', onDrag);
				document.addEventListener('touchmove', onDrag);
				document.addEventListener('mouseup',   onEnd);
				document.addEventListener('touchend',  onEnd);
				e.preventDefault();
			}

			function onDrag(e) {
				if (!isDragging) return;
				const evt = (e.touches ? e.touches[0] : e);
				let dx = evt.clientX - startX;
				let dy = evt.clientY - startY;
				let x = origX + dx;
				let y = origY + dy;

				const maxX = $dragWrapper.innerWidth()  - circle.offsetWidth;
				const maxY = $dragWrapper.innerHeight() - circle.offsetHeight;

				x = Math.max(0, Math.min(maxX, x));
				y = Math.max(0, Math.min(maxY, y));

				circle.style.left = x + 'px';
				circle.style.top  = y + 'px';
			}

			function onEnd() {
				isDragging = false;
				circle.style.cursor = 'grab';
				document.removeEventListener('mousemove', onDrag);
				document.removeEventListener('touchmove', onDrag);
				document.removeEventListener('mouseup',   onEnd);
				document.removeEventListener('touchend',  onEnd);
			}

			circle.addEventListener('mousedown', onStart);
			circle.addEventListener('touchstart', onStart);
		}
	});

	// EXPLODE IMAGE
	$(function () {
		const $section = $('.explode-image');
		const imgEl    = $section.find('img')[0];
		const $img     = $(imgEl);

		function initExplode () {
			const picture     = $section.find('picture')[0];
			const imageUrl    = imgEl.currentSrc || imgEl.src;
			const sectionRect = $section[0].getBoundingClientRect();
			const picRect     = picture.getBoundingClientRect();

			const gridTop  = picRect.top  - sectionRect.top;
			const gridLeft = picRect.left - sectionRect.left;
			const gridW    = picRect.width;
			const gridH    = picRect.height;

			const $grid = $section.find('.image-grid')
				.css({
					top:    gridTop  + 'px',
					left:   gridLeft + 'px',
					right:  'auto',
					bottom: 'auto',
					width:  gridW    + 'px',
					height: gridH    + 'px'
				})
				.empty()
				.addClass('opacity-0');

			const cols = 10, rows = 10, pieces = [];
			for (let i = 0; i < cols * rows; i++) {
				const x = i % cols, y = Math.floor(i / cols);
				const $piece = $('<div></div>')
					.addClass('will-change-transform')
					.css({
						width:              gridW / cols  + 'px',
						height:             gridH / rows  + 'px',
						'background-image': `url(${imageUrl})`,
						'background-size':  `${cols * 100}% ${rows * 100}%`,
						'background-position':
											`${(x / (cols - 1)) * 100}% ${(y / (rows - 1)) * 100}%`
					});
				$grid.append($piece);
				pieces.push($piece[0]);
			}

			const fallDist = window.innerHeight * 1.2;
			const tl = gsap.timeline({ paused: true })
				.set($grid,  { opacity: 1 }, 0)
				.to($img,    { autoAlpha: 0, duration: 0.1 }, 0)
				.to(pieces, {
					x:        () => gsap.utils.random(-120, 120),
					y:        fallDist,
					rotation: () => gsap.utils.random(-360, 360),
					scale:    () => gsap.utils.random(0.6, 1),
					opacity:  () => gsap.utils.random(0.5, 1),
					duration: 1.2,
					ease:     'power2.in',
					stagger:  { amount: 0.6 }
				}, 0.05)
				.to($grid[0], {
					opacity: 0,
					duration: 0.4,
					ease: 'power1.out',
					onComplete: () => {
						$grid.remove();
						$img.remove();
						if (window.innerWidth < 640) {
							$section.find('picture').remove();
						}
					}
				}, '-=0.2');

			const triggerStart = window.innerWidth < 640 ? 'top 30%' : 'top top';

			ScrollTrigger.create({
				trigger: $section[0],
				start:   triggerStart,
				once:    true,
				onEnter: () => tl.play()
			});
		}

		if (imgEl.complete && imgEl.naturalWidth) {
			initExplode();
		} else {
			$(imgEl).on('load', initExplode);
		}
	});
});
